import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00266 = new TileLayer({
  title: 'Máscara 20040917',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '200409173l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00266.setVisible(false);

const layer00265 = new TileLayer({
  title: 'Máscara 20041003',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20041003l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00265.setVisible(false);

const layer00264 = new TileLayer({
  title: 'Máscara 20041120',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20041120l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00264.setVisible(false);

const layer00263 = new TileLayer({
  title: 'Máscara 20041230',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20041230l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00263.setVisible(false);

const layer00262 = new TileLayer({
  title: 'Máscara 20050107',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050107l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00262.setVisible(false);

const layer00261 = new TileLayer({
  title: 'Máscara 20050131',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050131l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00261.setVisible(false);

const layer00260 = new TileLayer({
  title: 'Máscara 20050208',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050208l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00260.setVisible(false);

const layer00259 = new TileLayer({
  title: 'Máscara 20050216',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050216l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00259.setVisible(false);

const layer00258 = new TileLayer({
  title: 'Máscara 20050515',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050515l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00258.setVisible(false);

const layer00257 = new TileLayer({
  title: 'Máscara 20050523',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050523l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00257.setVisible(false);
  
const layer00256 = new TileLayer({
  title: 'Máscara 20050608',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050608l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00256.setVisible(false);
  
const layer00255 = new TileLayer({
  title: 'Máscara 20050616',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050616l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00255.setVisible(false);
  
const layer00254 = new TileLayer({
  title: 'Máscara 20050702',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050702l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00254.setVisible(false);

const layer00253 = new TileLayer({
  title: 'Máscara 20050718',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050803l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00253.setVisible(false);
  
const layer00252 = new TileLayer({
  title: 'Máscara 20050803',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20050803l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00252.setVisible(false);

export const grupoCapa01_17 = new LayerGroup({
  title: 'Ciclo Hidrológico 2004-2005',
  fold: 'close',
  layers: [layer00252, layer00253, layer00254, layer00255, layer00256, layer00257, layer00258, layer00259, layer00260, layer00261, layer00262, layer00263, layer00264, layer00265, layer00266]
});  